import {
    FETCH_WELLNESS_DAILY_SLEEP_DATA,
    UPDATE_SLEEP_DTO,
    UPDATE_WELLNESS_SLEEP_NOTE,
    UPDATE_SLEEP_WINDOW,
    UPDATE_WELLNESS_SLEEP_WINDOW,
    FETCH_DAILY_SLEEP_DATA_WITH_EPOCHS,
    UPDATE_SLEEP_NOTE,
    ADD_SLEEP,
    RESET_DAILY_SLEEP,
    SET_OPEN_TAB_ON_SLEEP_ONE_DAY_VIEW,
    FETCH_HRV_DAILY,
    FETCH_NAP_BY_DATE,
    ADD_NAP,
    DELETE_NAP,
    UPDATE_NAP
} from 'actions/ActionTypes';

/** NOTE
 * These actions are linked to wellness-service. Since there is a sleep-service now, they should be DEPRECATED.
 * Instead, use the actions at the bottom.
 */

export function fetchDailySleepData(displayName, calendarDate, nonSleepBufferMinutes, evictCache) {
    return {
        type: FETCH_WELLNESS_DAILY_SLEEP_DATA,
        displayName,
        calendarDate,
        nonSleepBufferMinutes,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function updateSleepDTO(newSleepDTO) {
    return {
        type: UPDATE_SLEEP_DTO,
        newSleepDTO
    };
}

export function updateWellnessSleepWindow(newSleepDTO, displayName, calendarDate, nonSleepBufferMinutes) {
    return {
        type: UPDATE_WELLNESS_SLEEP_WINDOW,
        newSleepDTO,
        displayName,
        calendarDate,
        nonSleepBufferMinutes
    };
}

export function updateWellnessSleepNote(userNote, displayName, calendarDate) {
    return {
        type: UPDATE_WELLNESS_SLEEP_NOTE,
        userNote,
        displayName,
        calendarDate
    };
}

/**
 * Use the actions below
 */
export function fetchDailySleepDataWithEpochs(calendarDate, nonSleepBufferMinutes, evictCache) {
    return {
        type: FETCH_DAILY_SLEEP_DATA_WITH_EPOCHS,
        calendarDate,
        nonSleepBufferMinutes,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function updateSleepNote(userNote, calendarDate) {
    return {
        type: UPDATE_SLEEP_NOTE,
        userNote,
        calendarDate
    };
}

export function updateSleepWindow(newSleepDTO, displayName, calendarDate, nonSleepBufferMinutes) {
    return {
        type: UPDATE_SLEEP_WINDOW,
        newSleepDTO,
        displayName,
        calendarDate,
        nonSleepBufferMinutes
    };
}

export function addSleep(sleepObject, calendarDate) {
    return {
        type: ADD_SLEEP,
        sleepObject,
        calendarDate
    };
}

export function resetDailySleep() {
    return {
        type: RESET_DAILY_SLEEP
    };
}

export function setOpenTabOnSleepOneDayView(tab) {
    return {
        type: SET_OPEN_TAB_ON_SLEEP_ONE_DAY_VIEW,
        tab
    };
}

export function fetchSleepByDate(calendarDate, evictCache) {
    return {
        type: FETCH_NAP_BY_DATE,
        calendarDate,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function fetchHrvByDate(startDate, endDate, evictCache) {
    return {
        type: FETCH_HRV_DAILY,
        startDate,
        endDate,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function addNap(napObject) {
    return {
        type: ADD_NAP,
        napObject
    };
}

export function deleteNap(calendarDate, startTimeInMilis) {
    return {
        type: DELETE_NAP,
        calendarDate,
        startTimeInMilis
    };
}

export function updateNap(calendarDate, startTimeInMilis, endTimeInMilis, updatedNapObject) {
    return {
        type: UPDATE_NAP,
        calendarDate,
        startTimeInMilis,
        endTimeInMilis,
        updatedNapObject
    };
}
